<template>
 <section>
    <base-card>
    <h2>Page not found</h2>
    <p>This page could not be found. Check out the <router-link to="/">Wisdoms</router-link> page? </p>
    </base-card>
 </section>
</template>